export const COLOR_CANTIDAD_PAGOS = '#0088FE';
export const COLOR_IMPORTE = '#00C49F';